import { gql, useQuery } from '@apollo/client';

export const GET_USER_ORG_DETAILS = gql`
  query getUserOrgDetails {
    getUserOrgDetails {
      businessName
      country
      email
      firstName
      hasPaymentMethod
      jobTitle
      lastName
      locality
      locationUid
      organizationUid
      phone
      postalCode
      region
      streetNumber
      uid
    }
  }
`;

const useGetUserOrgDetails = () => {
  const { data, loading, error } = useQuery(GET_USER_ORG_DETAILS);
  const userOrgDetails = data?.getUserOrgDetails || {};

  return {
    error,
    loading,
    userOrgDetails,
  };
};

export default useGetUserOrgDetails;
